const config = {
    // WS_BASE_URL: 'http://localhost:2345/',
    // DOMAIN_NAME: 'http://localhost:3000',
    // WS_BASE_URL: 'https://api.getdoobi.app/',
    // DOMAIN_NAME: 'https://dashboard.getdoobi.app',
    WS_BASE_URL: 'https://tapi.getdoobi.app/',
    DOMAIN_NAME: 'https://tdashboard.getdoobi.app',
    DEMO: true
}

export default config;
